var timeoutFlyOut;

var standardTimeout = 5000;
var mobileTimeoutOverride = 20000;
var currentTimeout;
var flyOutBrowserWidth;


var refreshFlyOutCartContentsInProgress = false;

function refreshFlyOutCartContents()
{
  if(refreshFlyOutCartContentsInProgress)
    return;


  refreshFlyOutCartContentsInProgress = true;
  
  timeoutFlyOut = clearTimeout(timeoutFlyOut);
  
  const cartUrl = '/cart';
  fetch(cartUrl)
  .then(response => response.text())
  .then(html => {
    const htmlParser = new DOMParser();
    //console.log('response html = ' + html);
    const documentParsed = htmlParser.parseFromString(html, 'text/html');
    const newCartItemsElement = documentParsed.querySelector('cart-items #main-cart-items');
    const newFooterItemsElement = documentParsed.querySelector('.cart__footer-wrapper');
    const newCartHeaderCount = documentParsed.querySelector('.cart-header-block');
    const newSamplesContentsItems = documentParsed.querySelector('#cart-items-sample-block-main .cart-items-samples-block-items');
    const newSamplesContentsValidation = documentParsed.querySelector('#cart-items-sample-block-main .cart-items-samples-block-validation');
    const newFreeShippingWidget = documentParsed.querySelector('.freeShippingWidget');

    const currentFreeShippingWidget = document.querySelector('.cart-fly-out-container .freeShippingWidget');
    console.log('newFreeShippingWidget');
      console.log(newFreeShippingWidget);    
    currentFreeShippingWidget.parentNode.replaceChild(newFreeShippingWidget, currentFreeShippingWidget);

    const currentCartItems = document.querySelector('cart-items #main-cart-items');    
    currentCartItems.parentNode.replaceChild(newCartItemsElement, currentCartItems);

    const currentFooterSection = document.querySelector('.cart__footer-wrapper');
    currentFooterSection.parentNode.replaceChild(newFooterItemsElement, currentFooterSection);

    const currentCartHeaderCount = document.querySelector('.nw-cart-fly-out-container-header-title');
    currentCartHeaderCount.innerHTML  = newCartHeaderCount.innerHTML ;

    var currentSamplesContentsItems = document.querySelector('#cart-items-sample-block-main .cart-items-samples-block-items');   
    if(currentSamplesContentsItems != null && newSamplesContentsItems != null)
      currentSamplesContentsItems.parentNode.replaceChild(newSamplesContentsItems, currentSamplesContentsItems);

    var currentSamplesContentsValidation = document.querySelector('#cart-items-sample-block-main .cart-items-samples-block-validation');   
    if(currentSamplesContentsValidation != null && newSamplesContentsValidation != null)
      currentSamplesContentsValidation.parentNode.replaceChild(newSamplesContentsValidation, currentSamplesContentsValidation);

    var cartItemList = document.querySelectorAll('cart-items #main-cart-items .cart-items .cart-item');
    var cartItemCount = cartItemList.length;
    if(cartItemCount > 0)
      document.querySelector('cart-items').classList.remove('is-empty');

    //document.querySelector('.product-form__buttons button').blur();
    openFlyOutCart();
    cartSuggestedItemsBuild();
    RefreshCartData();

    refreshFlyOutCartContentsInProgress = false;
  })
  .catch(error => console.log('error getting cart contents', error));
  updateFlyOutResize();
}

function updateFlyOutResize() {
  //console.log('updateFlyOutResize window.innerWidth = ' + window.innerWidth);
  flyOutBrowserWidth = clientContainerWidth = window.innerWidth;

}


var flyOutState = "closed";
var mouseFlyOutState = "mouseleave";

function closeFlyOutCart()
{
  document.querySelector('.cart-fly-out-container-background').style.display = "none";
  document.querySelector('.cart-fly-out-container').style.transform = "translateX(100%)";
  flyOutState = "closed";
}

function openFlyOutCart()
{
  updateFlyOutResize();
  document.querySelector('.cart-fly-out-container-background').style.display = "block";
  document.querySelector('.cart-fly-out-container').style.transform = "translateX(0%)";

  currentTimeout = standardTimeout;

  if(flyOutBrowserWidth <= 500)
  {
    currentTimeout = mobileTimeoutOverride;
  }
  
  timeoutFlyOut = setTimeout(closeFlyOutCart, currentTimeout);
  flyOutState = "open";

  document.querySelector('.cart-fly-out-container').focus();
  CartSamplesCheckShouldExpand();
}


function clickCloseCheck()
{
  if(flyOutState == "open" && mouseFlyOutState == "mouseleave")
    closeFlyOutCart();
}

function flyOutCartWireUpEvents()
{
  var flyOutContainer = document.querySelector('.cart-fly-out-container');
  
  flyOutContainer.addEventListener("mouseenter", (event) => {
    console.log("flyOutCartWireUpEvents mouseenter");
    timeoutFlyOut = clearTimeout(timeoutFlyOut);
    mouseFlyOutState = "mouseenter";
  });
  flyOutContainer.addEventListener("mouseleave", (event) => {
    console.log("flyOutCartWireUpEvents mouseleave");
    timeoutFlyOut = setTimeout(closeFlyOutCart, 3000);
    mouseFlyOutState = "mouseleave";
  });
  document.addEventListener("click", (event) => {
    //console.log("flyOutCartWireUpEvents mouse click");
    clickCloseCheck();
  });
  window.addEventListener('resize', updateFlyOutResize);
  flyOutContainer.addEventListener('touchstart', swipeStartFlyOutHandler);
  flyOutContainer.addEventListener('touchmove', swipeCurrentFlyOutHandler);
  flyOutContainer.addEventListener('touchend', swipeEndFlyOutHandler);
}



var startFlyOutSwipeStartX;
var startFlyOutSwipeStartY;
var currentFlyOutSwipeX;
var currentFlyOutSwipeY;


function swipeStartFlyOutHandler(e)
{
  startFlyOutSwipeStartX = e.touches[0].clientX;
  startFlyOutSwipeStartY = e.touches[0].clientY;
  //console.log('startFlyOutSwipeStartX' + startFlyOutSwipeStartX);
  //console.log('startFlyOutSwipeStartY' + startFlyOutSwipeStartY);
}
function swipeCurrentFlyOutHandler(e)
{
  currentFlyOutSwipeX = e.touches[0].clientX;
  currentFlyOutSwipeY = e.touches[0].clientY;

  timeoutFlyOut = clearTimeout(timeoutFlyOut);
  timeoutFlyOut = setTimeout(closeFlyOutCart, mobileTimeoutOverride);
  //console.log('currentFlyOutSwipeX ' + currentFlyOutSwipeX);
  //console.log('currentFlyOutSwipeY ' + currentFlyOutSwipeY);
  //swipeAmount += swipeDirection * swipeSpeed;
  
}
function swipeEndFlyOutHandler(e)
{
  var diffSwipeX = startFlyOutSwipeStartX - currentFlyOutSwipeX;
  //console.log('diffSwipeX ' + diffSwipeX);
  if(diffSwipeX < -100)
  {
    closeFlyOutCart();
  }
  startFlyOutSwipeStartX = 0;
  currentFlyOutSwipeX = 0;
  //console.log('swipeAmount' + swipeAmount);

 
}

addEventListener("DOMContentLoaded", (event) => {  flyOutCartWireUpEvents(); });

